import loader from './loader';

window.morningstar = {
    loader,
};



// WEBPACK FOOTER //
// ./src/index.js